const ___ASSET___0 = "/_app/immutable/assets/four_planes.03a4fcbd.svg";
export {
  ___ASSET___0 as _
};
